import { render } from "./Employee_EmergencyContact.vue?vue&type=template&id=4196d884"
import script from "./Employee_EmergencyContact.vue?vue&type=script&lang=js"
export * from "./Employee_EmergencyContact.vue?vue&type=script&lang=js"
script.render = render

export default script